import { SITE_PRIVACY_POLICY_URL, SITE_TERMS_OF_USE_URL } from '~/constants';
import ChooseSubscriptionModal from '~/modules/settings/components/modals/ChooseSubscriptionModal';
import { paymentAgreementJustdone } from '~/projects/justdone/config/agreementCopy';
import { ProjectRuntimeBehavior } from '~/projects/types';

const runtimeBehavior: ProjectRuntimeBehavior = {
  title: 'JustDone AI',
  fetchSubscriptionEndpoint: true,
  createFunnelUserBeforeSignUp: false,
  fetchTrustpilotInviteUrl: true,
  subscriptionFromProfileOnly: false,
  showSubscriptionUsageBlocks: true,
  withOnboardingMiddleware: true,
  settingsMainLayoutNoSidebar: false,
  loadDesktopSidebarThemeToggle: false,
  chatVendorDefaultIsGpt51: false,
  chatVendorSelectorAvailableWithoutFeatureFlag: false,
  chatUsesGptShellLayout: false,
  chatAnonymousSessionsEnabled: false,
  chatUsesChatwithaiEndpoints: false,
  showFrozenSubscriptionBlock: true,
  showHomeRetentionPopover: true,
  showTrustpilotMentions: true,
  openTrustpilotOnChatLike: true,
  shouldShowUpgradePaywallOnHandledBackendError: () => false,
  SubscriptionModal: ChooseSubscriptionModal,
  signUpUsesDeviceIdHeader: false,
  showNoActiveSubscriptionModal: true,
  usesPolyllmRedemptionCheckout: false,
  paymentConfigByRegion: {
    default: { getCompanyAddress: paymentAgreementJustdone },
  },
  personalInformationLegalLinksByRegion: {
    default: [],
    US: [
      { label: 'Terms of Service', href: SITE_TERMS_OF_USE_URL },
      { label: 'Privacy Policy', href: SITE_PRIVACY_POLICY_URL },
    ],
  },
};

export default runtimeBehavior;
